<div class="nav-container">

    <nav id="main-menu-navigation" class="navigation-main">
        <div class="nav-item "  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <a [routerLink]="['/auth/reception/reception']"><img src="assets/images/patients.png" class="img-fluid" alt="SEU"><span>{{'menu.Dailybookings' | translate}}</span></a>
      </div>

        <div class="nav-item "  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <a [routerLink]="['/auth/reception/add-new-booking']"><img src="assets/images/booking.png" class="img-fluid" alt="SEU"><span>{{'menu.booking' | translate}}</span></a>
        </div>
        
        <div class="nav-item "  routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a [routerLink]="['/auth/patient/patient-view']"><img src="assets/images/patients.png" class="img-fluid" alt="SEU"><span>{{'menu.patients' | translate}}</span></a>
  </div>
         
    </nav>
  </div>
